<template>
    <section class="dispatchOrder-table">
        <div class="dispatch-table-header">
            <el-button
                type="text"
                class="dispatch-refresh"
                icon="el-icon-upload2"
                @click="handleUpload"
                >上传</el-button
            >
            <el-button
                type="text"
                class="dispatch-refresh"
                icon="el-icon-refresh"
                @click="handleRefresh"
            >
                刷新
            </el-button>
        </div>
        <table-box
            ref="tablePage"
            :columns="config.table.columns"
            :height="config.table.height"
            :loading="loading"
            :rows="tableData"
            :actions="config.table.action"
            @action-click="actionClick"
        >
        </table-box>
        <m-page
            :current-page="currentPage"
            :pageData="config.page"
            :total="pageTotal"
            @on-page-change="pageChange"
            @on-size-change="sizeChange"
            class="page-container"
        ></m-page>
        <!-- 预览弹窗 -->
        <performance-preview-file
            :attachmentList="attachmentList"
            ref="performancePreviewFile"
        ></performance-preview-file>
        <!-- 预览弹窗 -->
        <!-- 文件上传弹窗 -->
        <dispatch-attachment-upload
            ref="imageManageUpload"
            v-if="fileUploadVisible"
            :visible.sync="fileUploadVisible"
            @update:attachmentUploadVisible="fileUploadVisible = false"
            @submit="fileUploadVisible = false"
            @uploadSuccess="uploadSuccess"
        ></dispatch-attachment-upload>
        <!-- 文件上传弹窗 -->
    </section>
</template>
<script>
import tableBox from '@/components/lots/tableBox/Index.vue';
import mPage from '@/components/otpPanel/mPage';
import PerformancePreviewFile from '@/modules/transport/otp/components/PerformancePreviewFile';
import dispatchAttachmentUpload from '../../components/dispatchAttachmentUpload/Index';
import {
    attAchment, getAchmentPage, attachmentDelete
}
    from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import config from './config.js';

export default {
    name: 'dispatchArrivalCheckInTable',
    components: { tableBox, mPage, PerformancePreviewFile, dispatchAttachmentUpload },
    props: {
        infoId: {
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config,
            loading: false,
            selected: [], // 选中数据
            tableData: [
            ], // 列表数据
            page: {
                pageSize: 10,
                pageNo: 1
            },
            pageTotal: 0,
            currentPage: 1,
            fileUploadVisible: false,
            attachmentList: []

        };
    },
    methods: {
        /**
         * @description 操作列事件处理
         * @event {事件类型} viewImg 查看影像
         * @row   {Object} 行数据
        */
        actionClick (event, row, rIndex) {
            /* eslint-disable indent */
            switch (event) {
                case 'viewImg':
                    this.attachmentList = [row];
                    this.$nextTick(() => {
                        this.$refs.performancePreviewFile.show();
                    });
                    break;
                case 'delete':
                    this.handleAttachmentDelete(row.id);
                    break;
                default:
                    break;
            }
        },
        /**
         * @description 文件删除
         * @param {String} id  文件id
         */
        handleAttachmentDelete (id) {
            attachmentDelete(id).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('删除成功');
                    this.getList();
                }
            });
        },
        // 页数改变
        sizeChange (data) {
            this.page.pageSize = data;
            this.getList();
        },
        // 切分页
        pageChange (data) {
            this.page.pageNo = data;
            this.getList();
        },
        /**
         * @getList 获取列表接口
         * @param {Object} searchParams 查询条件
         */
        async getList () {
            const param = {
                ...this.page,
                param: {
                    objType: 'ARRIVAL_REGISTER',
                    objId: this.infoId
                }
            };
            getAchmentPage(param).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data.totalCount || 0;
                    this.tableData = this.formatResponseList(res.data.list || []);
                    this.$emit('fileList', this.tableData);
                }
            });
        },
        /**
         * @description 格式化列表数据
         */
        formatResponseList (array) {
            array.forEach(e => {
                e.objTypeName = e.objType ? this.dictData.OTP_ATTACHMENT_TYPE[e.objType] : '';
            });
            return array;
        },
        /**
         * @description 刷新
        */
        handleRefresh () {
            this.page = {
                pageSize: 10,
                pageNo: 1
            };
            this.getList();
        },
        // 参数为空处理
        getSearchData (data) {
            const _searchData = {
                ...this.page,
                ...data,
                pageNo: 1
            };
            for (const key in _searchData) {
                if (_searchData[key] === '') delete _searchData[key];
            }
            return _searchData;
        },
        handleUpload () {
            this.fileUploadVisible = true;
        },
        // 上传附件
        uploadSuccess (data) {
            const param = {
                objType: 'ARRIVAL_REGISTER',
                objId: this.infoId,
                fileSize: data.fileSize,
                name: data.name,
                path: data.downUrl
            };
            attAchment(param).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('上传成功');
                    this.getList();
                    this.fileUploadVisible = false;
                }
            });
        }
    },
    mounted () {
        this.getList();
    }

};
</script>

<style  lang="less" scoped>
.dispatchOrder-table {
}
.dispatchOrder-table .model-table-search {
    display: none;
}
.page-container {
    margin-top: 10px;
}
</style>
